import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['button', 'content']

  connect() {
    // Inicialización cuando el controlador se conecta
  }

  toggle(event) {
    const button = event.currentTarget
    const index = button.dataset.index
    const content = this.contentTargets.find(content => content.dataset.index === index)

    if (content) {
      if (content.classList.contains('hidden')) {
        content.classList.remove('hidden')
        button.querySelector('svg').classList.add('transform', 'rotate-180')
      } else {
        content.classList.add('hidden')
        button.querySelector('svg').classList.remove('transform', 'rotate-180')
      }
    }
  }
}
